import * as React from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';

export default function NavesSilosComponents() {


    const initialData = [
        {
            ProductID: 1,
            ProductName: "Silo A",
            FirstOrderedOn: new Date(2024, 4, 10),
            UnitsInStock: 20,
            Discontinued: false,
        },
        {
            ProductID: 2,
            ProductName: "Silo B",
            FirstOrderedOn: new Date(2024, 5, 2),
            UnitsInStock: 15,
            Discontinued: true,
        },
        {
            ProductID: 3,
            ProductName: "Silo C",
            FirstOrderedOn: new Date(2024, 2, 25),
            UnitsInStock: 10,
            Discontinued: false,
        }
    ];

    const [data, setData] = React.useState(initialData);
    const [originalData, setOriginalData] = React.useState(initialData);
    const [hasChanges, setHasChanges] = React.useState(false);

    // Al hacer clic en una fila, habilita edición
    const rowClick = event => {
        const id = event.dataItem.ProductID;
        setData(data.map(item =>
            item.ProductID === id ? { ...item, inEdit: true } : item
        ));
    };

    // Maneja cambios en celdas editables
    const handleItemChange = event => {
        const id = event.dataItem.ProductID;
        const field = event.field || '';
        const newData = data.map(item =>
            item.ProductID === id
                ? { ...item, [field]: event.value }
                : item
        );
        setData(newData);
        setHasChanges(true);
    };

    // Controla el estado de edición de una fila
    const handleEditChange = event => {
        const id = event.dataItem.ProductID;
        setData(data.map(item =>
            item.ProductID === id
                ? { ...item, inEdit: event.value }
                : item
        ));
    };

    // Agrega un nuevo registro
    const addRecord = () => {
        const id = Math.max(...data.map(d => d.ProductID), 0) + 1;
        const newRecord = {
            ProductID: id,
            ProductName: '',
            FirstOrderedOn: new Date(),
            UnitsInStock: 0,
            Discontinued: false,
            inEdit: true
        };
        setData([newRecord, ...data]);
        setHasChanges(true);
    };

    const saveChanges = () => {
        const cleanedData = data.map(item => ({ ...item, inEdit: false }));
        setData(cleanedData);
        setOriginalData(cleanedData);
        setHasChanges(false);
    };

    const cancelChanges = () => {
        setData(originalData.map(item => ({ ...item, inEdit: false })));
        setHasChanges(false);
    };

    const removeItem = (dataItem) => {
        setData(data.filter(item => item.ProductID !== dataItem.ProductID));
        setOriginalData(originalData.filter(item => item.ProductID !== dataItem.ProductID));
        setHasChanges(true);
    };


    return (
        <div className="container-fluid mt-4">
            <div className="col-12 col-lg-11 mx-auto">


                <Grid
                    style={{ height: '420px' }}
                    data={data}
                    dataItemKey="ProductID"
                    editField="inEdit"
                    onItemChange={handleItemChange}
                    onEditChange={handleEditChange}
                    onRowClick={rowClick}
                >
                    <GridToolbar>
                        <Button onClick={addRecord}>
                            Add New
                        </Button>
                        <Button onClick={saveChanges} disabled={!hasChanges} style={{ marginLeft: 10 }}>
                            Save Changes
                        </Button>
                        <Button onClick={cancelChanges} disabled={!hasChanges} style={{ marginLeft: 10 }}>
                            Cancel Changes
                        </Button>
                    </GridToolbar>
                    <Column
                        cell={(props) => ( <td>
                                <Button onClick={() => removeItem(props.dataItem)}>
                                    Eliminar
                                </Button>
                            </td>)} width="120px"/>
                    <Column field="ProductID" title="Id" width="50px" editable={false} />
                    <Column field="ProductName" title="Name" />
                    <Column field="FirstOrderedOn" title="First Ordered" editor="date" format="{0:d}" />
                    <Column field="UnitsInStock" title="Units" width="150px" editor="numeric" />
                    <Column field="Discontinued" title="Discontinued" editor="boolean" />
                </Grid>
            </div>
        </div>
    );
}